module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAAGzCI4dAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACKADAAQAAAABAAAACAAAAACVhHtSAAAAjklEQVQYGUWPIRLCMBBFkzgmPUHjuUY9HsM9cL1CBAKF4yD1DDIH4AQo6sP7O0n7Z1528/dPu3FuU601wc0Mmhza7eVpIvYHBnj0yFcNw7cZ/cAocq9gsgHd2O4nGQF+kOAA9qEziQwXOIKtQJWyhVowYhSz+8YMlJ5Ba62weESd8O7UXS2of2tTPfCp/g+b3XldvbNzLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav-point.png
// module id = 26LG
// module chunks = 15